<template>
  <div v-if="banners.length" class="promo-list">
    <div
      v-for="banner in banners"
      :key="banner.key"
      class="promo-banner"
      :class="`promo-banner--${banner.variant}`"
    >
      <div class="promo-accent" aria-hidden="true"></div>
      <div class="promo-content">
        <div class="promo-chip">
          <v-icon x-small class="mr-1">{{ banner.icono }}</v-icon>
          {{ banner.chip }}
        </div>
        <div class="promo-title">{{ banner.titulo }}</div>
        <div class="promo-desc">{{ banner.descripcion }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PromoBanner',
  props: {
    grupoId: {
      default: null,
      validator (value) {
        return value === null || value === undefined || typeof value === 'number'
      }
    },
    mostrarFormaPago: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      clientData: 'App/data'
    }),
    banners () {
      if (!this.clientData || !this.clientData.Descuentos) return []

      const result = []
      const descuentos = this.clientData.Descuentos.filter(d => this.puedeMostrarBanner(d))

      if (this.grupoId) {
        const descuentoGrupo = descuentos.find(d => d.GrupoId === this.grupoId && d.Cantidad > 0)
        if (descuentoGrupo) {
          result.push(this.buildBannerGrupo(descuentoGrupo))
        }
      }

      if (this.mostrarFormaPago) {
        descuentos
          .filter(d => d.FPagoId > 0)
          .forEach(d => {
            result.push(this.buildBannerFormaPago(d))
          })
      }

      return result
    }
  },
  methods: {
    puedeMostrarBanner (d) {
      return d.MostrarBannerTienda === true ||
        d.MostrarBannerTienda === undefined ||
        d.MostrarBannerTienda === null
    },
    nombreGrupo (descuento) {
      if (descuento && descuento.GrupoNombre) {
        return descuento.GrupoNombre.toLowerCase()
      }
      return 'productos'
    },
    nombreFormaPago (fPagoId) {
      if (!this.clientData || !this.clientData.formasPago) return 'esta forma de pago'
      const formaPago = this.clientData.formasPago.find(fp => fp.id === fPagoId)
      return formaPago && formaPago.name ? formaPago.name : 'esta forma de pago'
    },
    buildBannerGrupo (descuento) {
      const metodoCalculo = descuento.TipoDescuento || 'P'
      const cantidad = descuento.Cantidad
      const nombreGrupo = this.nombreGrupo(descuento)
      let titulo
      let descripcion
      let chip
      let icono = 'mdi-percent'

      if (metodoCalculo === 'C') {
        chip = `${cantidad}x`
        titulo = `Promo ${cantidad} × $${descuento.PorcentajeDesct.toFixed(0)}`
        descripcion = `Llevá ${cantidad} ${nombreGrupo} por solo $${descuento.PorcentajeDesct.toFixed(0)}`
        icono = 'mdi-gift-outline'
      } else if (metodoCalculo === 'I') {
        chip = `-$${descuento.PorcentajeDesct.toFixed(0)}`
        titulo = `Comprá ${cantidad} y ahorrá`
        descripcion = `Descuento de $${descuento.PorcentajeDesct.toFixed(0)} al comprar ${cantidad} ${nombreGrupo}`
        icono = 'mdi-cash'
      } else {
        chip = `${descuento.PorcentajeDesct}% OFF`
        titulo = `${descuento.PorcentajeDesct}% OFF en ${cantidad} ${nombreGrupo}`
        descripcion = `Descuento adicional al comprar ${cantidad} ${nombreGrupo}`
      }

      return {
        key: `grupo_${descuento.GrupoId}_${cantidad}`,
        titulo,
        descripcion,
        chip,
        icono,
        variant: 'grupo'
      }
    },
    buildBannerFormaPago (descuento) {
      const metodoCalculo = descuento.TipoDescuento || 'P'
      const nombrePago = this.nombreFormaPago(descuento.FPagoId)
      let titulo
      let descripcion
      let chip
      let icono = 'mdi-percent'

      if (metodoCalculo === 'I') {
        chip = `-$${descuento.PorcentajeDesct.toFixed(0)}`
        titulo = `Ahorrá pagando con ${nombrePago}`
        descripcion = `Descuento de $${descuento.PorcentajeDesct.toFixed(0)} al elegir ${nombrePago}`
        icono = 'mdi-cash'
      } else {
        chip = `${descuento.PorcentajeDesct}% OFF`
        titulo = `${descuento.PorcentajeDesct}% OFF con ${nombrePago}`
        descripcion = `Descuento al elegir ${nombrePago} como forma de pago`
      }

      return {
        key: `fpago_${descuento.FPagoId}`,
        titulo,
        descripcion,
        chip,
        icono,
        variant: 'pago'
      }
    }
  }
}
</script>

<style scoped>
.promo-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
}
.promo-banner {
  position: relative;
  display: flex;
  align-items: stretch;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: none;
}
.promo-accent {
  width: 4px;
  flex-shrink: 0;
}
.promo-banner--pago .promo-accent {
  background: #00897b;
}
.promo-banner--grupo .promo-accent {
  background: #e65100;
}
.promo-banner--pago {
  background: linear-gradient(90deg, rgba(0, 137, 123, 0.06) 0%, #fff 42%);
}
.promo-banner--grupo {
  background: linear-gradient(90deg, rgba(230, 81, 0, 0.06) 0%, #fff 42%);
}
.promo-content {
  padding: 12px 14px;
  min-width: 0;
  flex: 1;
}
.promo-chip {
  display: inline-flex;
  align-items: center;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 3px 8px;
  border-radius: 999px;
  margin-bottom: 6px;
  line-height: 1;
}
.promo-banner--pago .promo-chip {
  background: rgba(0, 137, 123, 0.12);
  color: #00695c;
}
.promo-banner--grupo .promo-chip {
  background: rgba(230, 81, 0, 0.12);
  color: #bf360c;
}
.promo-title {
  font-size: 0.98rem;
  font-weight: 700;
  line-height: 1.25;
  color: rgba(0, 0, 0, 0.9);
}
.promo-desc {
  margin-top: 3px;
  font-size: 0.8rem;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.55);
}
</style>
